
import { z } from "zod";

export const SmsStatusValues = ["ACCEPTED", "CANCELED", "DELIVERED", "FAILED", "QUEUED", "READ", "RECEIVED", "SCHEDULED", "SENT", "UNDELIVERED"] as const;
export const SmsStatusSchema = /* @__PURE__ */ z.enum(SmsStatusValues);
export const SmsStatus: (typeof SmsStatusSchema)["enum"] = { "ACCEPTED": "ACCEPTED", "CANCELED": "CANCELED", "DELIVERED": "DELIVERED", "FAILED": "FAILED", "QUEUED": "QUEUED", "READ": "READ", "RECEIVED": "RECEIVED", "SCHEDULED": "SCHEDULED", "SENT": "SENT", "UNDELIVERED": "UNDELIVERED" };
export type SmsStatus = (typeof SmsStatusValues)[number];
export const SmsStatusDisplayNames = { "ACCEPTED": "Accepted",
"CANCELED": "Canceled",
"DELIVERED": "Delivered",
"FAILED": "Failed",
"QUEUED": "Queued",
"READ": "Read",
"RECEIVED": "Received",
"SCHEDULED": "Scheduled",
"SENT": "Sent",
"UNDELIVERED": "Undelivered", } satisfies Record<SmsStatus, string>;
